import { render } from "./Moban.vue?vue&type=template&id=755caf6c&scoped=true"
import script from "./Moban.vue?vue&type=script&lang=js"
export * from "./Moban.vue?vue&type=script&lang=js"

import "./Moban.vue?vue&type=style&index=0&id=755caf6c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-755caf6c"]])

export default __exports__